<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left-title">
        <h1 class="title is-3">
          <span class="">Analyse coût de communication</span>
        </h1>
      </div>
      <div class="column is-paddingless is-border-left" slot="left-action" v-if="isAdmin">
        <router-link :to="{name: 'OriginList'}"
          class="page-header-btn is-small">
            <span class="icon is-small">
                <i class="fal fa-list"></i>
            </span>
            <span>Gestion des origines</span>
          </router-link>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a class="page-header-btn tooltip is-square is-tooltip-left is-tooltip-primary" :data-tooltip="fullscreen ? 'Réduire' : 'Agrandir'" @click="toggleFullscreen">
          <span class="icon">
            <i class="fal" :class="fullscreen ? 'fa-compress-wide' : 'fa-expand-wide'"></i>
          </span>
        </a>
      </div>
    </sticky>

    <!-- <div class="is-tab-like is-light is-border-bottom is-padding-left is-inline-block full-width">
      <a class=" button is-light has-text-grey is-transform-none is-border-right is-pulled-left is-active">Tableau</a>
      <a disabled="disabled" class=" button is-light has-text-grey is-transform-none is-border-right is-pulled-left">Chart
        &nbsp; <span class="tag is-xsmall is-warning">SOON</span>
      </a>
    </div> -->
    <div class="page-content is-padding-top">
      <div class="columns is-sticky-in-mainColumn is-zindex-8 is-gapless has-bg-white is-margin-left is-margin-right is-border">
        <div class="column is-10 is-8-widescreen">
          <stats-menu></stats-menu>
        </div>
        <div class="column"></div>
      </div>

      <div class="is-padding-top is-padding-left is-padding-right" data-sticky-pos-top="headerStats">
        <div class="has-bg-white is-border is-radius-large">
          <div class="columns is-vcentered is-gapless">
            <div class="column">
              <div class="tabs is-marginless-bottom is-radius-top-left">
                <ul class="has-text-weight-medium is-borderless">
                  <li :class="{'is-active': currentTab === TAB_MODES.TABLE}">
                    <a @click="changeTab(TAB_MODES.TABLE)">Tableaux</a></li>
                  <li :class="{'is-active': currentTab === TAB_MODES.CHART}" class="is-disabled">
                    <a disabled="true" style="cursor: not-allowed;">
                      <span>Charts</span><span class="tag is-small">soon</span></a></li>
                </ul>
              </div>
            </div>
            <!-- <div class="column is-narrow">
              <a class="has-text-grey is-size-6 is-uppercase">
                <span class="icon"><i class="fal fa-expand-wide"></i></span>
                <span>Agrandir</span>
              </a>
            </div> -->
          </div>
          <div class="columns has-bg-light is-radius-bottom-left is-radius-bottom-right">
            <div class="column is-size-6 ">
              <span class="has-text-grey is-underline has-text-weight-normal is-dotted"
                    @click="openMonthPicker">{{currentDateLabel}}</span>
              <datepicker id="monthpicker" @selected="loadOriginStats" v-model="rawDate" language="fr" ref="monthpicker"
                          :minimumView="'month'" :maximumView="'month'">
              </datepicker>
            </div>
          </div>
        </div>

        <div v-if="currentTab === TAB_MODES.TABLE"
             class="is-border-top is-radius-top-left-large is-radius-top-right-large is-margin-top"
             id="tableaux">

          <div class="stat-header stat-header--sticky is-border-right is-border-left has-bg-white"
            :style="stickyStyles"
          >
            <div class="columns is-gapless is-size-7-touch is-size-7-desktop is-size-6-widescreen">
              <div class="columns column is-3 is-th">
                <div class="column is-8 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('name')">
                    <span>Support</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'name'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'name' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('contacts')">
                    <span>Nbre de contacts</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'contacts'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'contacts' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
              </div>
              <div class="columns column is-6">
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('rdvs')">
                    <span>RDV</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'rdvs'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'rdvs' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a>
                    <span>Prix du contact</span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a>
                    <span>Prix du RDV</span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a>
                    <span>Coût total</span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('advs')">
                    <span>Nbre de vente</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'advs'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'advs' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a>
                    <span>Marge vente</span>
                  </a>
                </div>
              </div>
              <div class="columns column is-3">
                <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a>
                    <span>Ratio coût vente</span>
                  </a>
                </div>
                <div class="column is-5 is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a>
                    <span>Marge dégagée</span>
                  </a>
                </div>
                <div class="column is-3 is-paddingless"></div>
              </div>
            </div>
          </div>

          <div class="stat-lignes">


            <origin-row v-for="o in orderedOriginStats" :key="o.pk" @open="openOrigin"
                        :origin="o"
                        :date="currentDate"
                        :is-open="currentOrigin && currentOrigin.pk === o.pk"
                        class="has-bg-white is-border is-relative is-margin-bottom-small">
            </origin-row>
            <origin-row key="total"
                        :origin="totalRow"
                        :date="currentDate"
                        :can-be-remove="false"
                        :is-total="true"
                        class="stat-ligne stat-ligne--synthese">
            </origin-row>

          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import OriginRow from './OriginRow'
  import { orderBy } from 'lodash'
  import { mapGetters } from 'vuex'
  import StatsMenu from '../StatsMenu'
  import { StatsStickyMx } from '@/mixins'

  const TAB_MODES = Object.freeze({
    TABLE: 'TABLE',
    CHART: 'CHART'
  })

  export default {
    name: 'Multidiffusion',
    mixins: [StatsStickyMx],
    components: {
      Datepicker,
      OriginRow,
      StatsMenu
    },
    props: {},
    data () {
      return {
        TAB_MODES: TAB_MODES,
        currentTab: TAB_MODES.TABLE,
        sortBy: null,
        sortOrder: 'desc',
        isLoading: false,
        rawDate: null,
        rawOriginStats: null,
        currentOrigin: null,
        origins: [],
        fullscreen: false
      }
    },
    computed: {
      ...mapGetters(['isAdmin']),
      totalRow () {
        // eslint-disable-next-line camelcase
        let monthly_costs = this.originStats.reduce((accum, val) => {
          return accum.concat(val.data.monthly_costs)
        }, [])

        return {
          name: 'SYNTHÈSE',
          rdvs: this.originStats.reduce((accum, val) => { return accum + val.rdvs }, 0),
          contacts: this.originStats.reduce((accum, val) => { return accum + val.contacts }, 0),
          advs: this.originStats.reduce((accum, val) => { return accum + val.advs }, 0),
          data: {
            monthly_costs: monthly_costs
          }
        }
      },
      orderedOriginStats () {
        if (this.sortBy) {
          return orderBy(this.originStats, this.sortBy, this.sortOrder)
        } else {
          return this.originStats
        }
      },
      currentDate () {
        return moment(this.rawDate)
      },
      currentMonth () {
        return this.currentDate.format('MM')
      },
      currentYear () {
        return this.currentDate.format('YYYY')
      },
      currentDateLabel () {
        return this.currentDate.format('MMMM YYYY')
      },
      originStats () {
        if (!this.rawOriginStats) {
          return []
        }
        return Object.values(this.rawOriginStats).map(x => {
          x.children = Object.values(x.children)
          if (x.children && x.children.length > 0) {
            x.contacts = x.children.reduce((accum, val) => {
              return accum + val.contacts.length
            }, 0)
            x.rdvs = x.children.reduce((accum, val) => {
              return accum + val.rdvs.length
            }, 0)
            x.advs = x.children.reduce((accum, val) => {
              return accum + val.advs.length
            }, 0)
          } else {
            x.contacts = x.contacts.length
            x.rdvs = x.rdvs.length
            x.advs = x.advs.length
          }
          return x
        })
      }
    },
    methods: {
      changeTab (tab) {
        this.currentTab = tab
      },
      sort (sortBy) {
        if (this.sortBy !== sortBy) {
          this.sortOrder = 'asc'
        } else {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        }
        this.sortBy = sortBy
      },
      openOrigin (origin) {
        if (this.currentOrigin && this.currentOrigin.pk === origin.pk) {
          this.currentOrigin = null
        } else {
          this.currentOrigin = origin
        }
      },
      loadOriginStats () {
        this.isLoading = true
        this.rawOriginStats = null
        let filters = {
          start_date: this.currentDate.startOf('month').format('DD/MM/YYYY'),
          end_date: this.currentDate.endOf('month').format('DD/MM/YYYY')
        }
        this.$api.originService.getStats(filters)
          .then(res => {
            this.rawOriginStats = res.data
            this.isLoading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
      loadOrigins () {
        this.origins = []
        this.$api.originService.get({sort: 'name:asc'})
          .then(res => {
            this.origins = res.data.items
            this.isLoading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
      openMonthPicker () {
        this.$refs.monthpicker.showCalendar()
      },
      toggleFullscreen () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('body').classList.add('has-contentmain-fullscreen')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen-leave')
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('body').classList.add('has-contentmain-fullscreen-leave')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen')
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      }
    },
    created () {
      this.rawDate = new Date()
      this.loadOriginStats()
    }
  }
</script>

<style>
  #monthpicker {
    display: none;
    height: 0;
    width: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/statistics/multidiffusion/Multidiffusion.vue